var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.collaborators.length
        ? _c("staff-group", {
            attrs: {
              placeholder: _vm.$t.__("timeline.TimelineAuthorFilter.all_staff"),
              collaborators: _vm.collaborators,
              selectedCollaborator: _vm.selected
            },
            on: { input: _vm.collaboratorsSelected }
          })
        : _c("span", [
            _vm._v(
              _vm._s(_vm.$filters.capitalize(_vm.$l10n.__("indisponible")))
            )
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }